module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-link",
    attrs: {
      "to": '/newUser/' + _vm.usertype
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  }), _vm._v("Create new " + _vm._s(_vm.usertype) + "\n  ")]), _vm._v(" "), (_vm.usertype === 'admin') ? _c('div', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.usertype === 'client') ? _c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 0
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Clients")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 1
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Prospects")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.tab === 2
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 2
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Archived")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.userlist), function(user, key) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-1 col-md-2"
    }, [_c('router-link', {
      attrs: {
        "to": '/users/' + user._id,
        "user": user
      }
    }, [_c('avatar', {
      key: user._id,
      attrs: {
        "user": user
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "column col-11 col-md-10"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column col-4 col-md-12"
    }, [_c('router-link', {
      attrs: {
        "to": '/users/' + user._id
      }
    }, [_vm._v("\n              " + _vm._s(user.profile.corporate ? user.profile.business : user.profile.firstname + ' ' + user.profile.lastname) + "\n            ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "column col-4 col-md-12"
    }, [_c('a', {
      attrs: {
        "href": ("mailto:" + (user.email))
      }
    }, [_vm._v(_vm._s(user.email))])]), _vm._v(" "), _c('div', {
      staticClass: "column col-4 col-md-12"
    }, [_c('a', {
      attrs: {
        "href": ("tel:" + (user.profile.phone))
      }
    }, [_vm._v(_vm._s(user.profile.phone))])])])])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57efe95a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/users.vue
// module id = 501
// module chunks = 1